import httpClient from "../http";

export const adminApi = {
  signin: (data) => httpClient.post("/admin/signin", data),
  verifyMfa: (data) => httpClient.post("/admin/mfa/verify", data),
  mfaStatus: () => httpClient.get("/admin/mfa/status"),
  mfaSetup: () => httpClient.post("/admin/mfa/setup"),
  mfaEnable: (data) => httpClient.post("/admin/mfa/enable", data),
  mfaDisable: (data) => httpClient.post("/admin/mfa/disable", data),
  logout: () => httpClient.post("/admin/logout"),
  getStats: () => httpClient.get("/admin/stats"),
  getUserTrends: (days = 30) => httpClient.get("/admin/user-trends", { params: { days } }),
  getUsers: (params) => httpClient.get("/admin/users", { params }),
  getUserDetail: (id) => httpClient.get(`/admin/users/${id}`),
  toggleUserActive: (id) => httpClient.patch(`/admin/users/${id}/toggle-active`),
  createAdmin: (data) => httpClient.post("/admin/create-admin", data),
  // Subscription plans
  getPlans: (active) => httpClient.get("/subscription/admin/plans", { params: { active } }),
  getPlanById: (id) => httpClient.get(`/subscription/admin/plans/${id}`),
  createPlan: (data) => httpClient.post("/subscription/admin/plans", data),
  updatePlan: (id, data) => httpClient.patch(`/subscription/admin/plans/${id}`, data),
  togglePlanStatus: (id) => httpClient.patch(`/subscription/admin/plans/${id}/toggle-status`),
  getTrialConfig: () => httpClient.get("/subscription/admin/trial-config"),
  setTrialConfig: (data) => httpClient.patch("/subscription/admin/trial-config", data),
  // Subscriptions
  getAllSubscriptions: (params) => httpClient.get("/subscription/admin/subscriptions", { params }),
  // Credit balances
  getAllCreditBalances: (params) => httpClient.get("/subscription/admin/credit-balances", { params }),
};
